import React, { useState } from 'react';
import './styles/Availability.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Availability = () => {
  const timeSlots = [
    'Morning (9-12)',
    'Afternoon (12-4)',
    'Evening (4-8)',
    'Night (8-12)',
  ];
  const daysOfWeek = ['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat'];

  const today = new Date();
  const startOfWeekInitial = new Date(
    today.setDate(today.getDate() - today.getDay()),
  );
  const [weekStart, setWeekStart] = useState(startOfWeekInitial);

  const [availabilityGrid, setAvailabilityGrid] = useState([
    [
      'available',
      'preferred',
      'available',
      'available',
      null,
      'preferred',
      null,
    ],
    [
      'preferred',
      'available',
      'available',
      'preferred',
      'available',
      'available',
      'preferred',
    ],
    [null, 'preferred', 'available', null, 'preferred', null, null],
    [
      'available',
      'preferred',
      'preferred',
      'available',
      'available',
      'available',
      'preferred',
    ],
  ]);

  const toggleAvailability = (rowIndex, dayIndex) => {
    const newGrid = [...availabilityGrid];
    const currentState = newGrid[rowIndex][dayIndex];
    if (currentState === null) newGrid[rowIndex][dayIndex] = 'available';
    else if (currentState === 'available')
      newGrid[rowIndex][dayIndex] = 'preferred';
    else newGrid[rowIndex][dayIndex] = null;
    setAvailabilityGrid(newGrid);
  };

  // Week navigation
  const handlePrevWeek = () => {
    const newStart = new Date(weekStart);
    newStart.setDate(weekStart.getDate() - 7);
    setWeekStart(newStart);
  };

  const handleNextWeek = () => {
    const newStart = new Date(weekStart);
    newStart.setDate(weekStart.getDate() + 7);
    setWeekStart(newStart);
  };

  const getWeekRange = () => {
    const end = new Date(weekStart);
    end.setDate(weekStart.getDate() + 6);
    return `${weekStart.toDateString()} - ${end.toDateString()}`;
  };

  // Generate days for header with actual dates
  const getWeekDays = () => {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(weekStart);
      date.setDate(weekStart.getDate() + i);
      days.push({ day: daysOfWeek[i], date: date.getDate() });
    }
    return days;
  };

  const weekDays = getWeekDays();

  return (
    <div className="container-availability">
      <div className="week-header-availability">
        <FaChevronLeft
          className="week-arrow-availability"
          onClick={handlePrevWeek}
        />
        <span className="week-label-availability">{getWeekRange()}</span>
        <FaChevronRight
          className="week-arrow-availability"
          onClick={handleNextWeek}
        />
      </div>

      <div className="grid-availability">
        <div className="header-availability">
          <div className="header-cell-availability"></div>
          {weekDays.map((day, index) => (
            <div key={index} className="day-availability">
              {day.day} <br /> {day.date}
            </div>
          ))}
        </div>

        <div className="body-availability">
          <div className="times-availability">
            {timeSlots.map((time, index) => (
              <div key={index} className="time-availability">
                {time}
              </div>
            ))}
          </div>

          <div className="rows-availability">
            {availabilityGrid.map((row, rowIndex) => (
              <div key={rowIndex} className="row-availability">
                {row.map((cellState, dayIndex) => (
                  <div
                    key={dayIndex}
                    className={`cell-availability ${
                      cellState || 'unavailable'
                    }`}
                    onClick={() => toggleAvailability(rowIndex, dayIndex)}
                  ></div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Availability;
